// extracted by mini-css-extract-plugin
export var sliderRange = "_p7-2";
export var sliderRoot = "_p7-0";
export var sliderThumb = "_p7-3";
export var sliderTrack = "_p7-1";